import type { FeeRecord } from '../services/smr-admin';
import type { ProductFeeRecord } from '../services/productFees';

export type CatalogueFee = Pick<FeeRecord, 'id' | 'name' | 'transaction_type_id'>;

export function withEditRowFee(fees: CatalogueFee[], row: ProductFeeRecord | undefined): CatalogueFee[] {
    if (!row || fees.some((fee) => fee.id === row.fee_id)) return fees;
    return [
        ...fees,
        { id: row.fee_id, name: row.fee.name, transaction_type_id: row.fee.transaction_type?.id ?? '' },
    ];
}
